import React, { Fragment } from 'react';
import { Grid, FormControl, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import ActionButton from '../../ActionButton/ActionButton';
import Forum from '@mui/icons-material/Forum';
import { RandomDataWarning } from '../../Display/Display';
import { creativityOptions } from '../constant';
import TopicResult from '../Component/TopicResult';
import FormLabelWithIcon from '../../Inputs/FormLabelWithIcon';
import { SECTION_GAP } from '../../Inputs/inputStyles';

export const TopicSuggestionView = ({
  intl,
  options,
  onValueChange,
  classes = {},
  text,
  onGenerate,
  onClear,
  readonly
}) => {
  const _readonly = readonly ?? !!text;
  return (
    <Fragment>
      {/* This view is the ONE place in these drawers whose rows are not direct
          children of the drawer's own spaced Grid — this FormControl sits
          between them — so the drawer's `spacing={2}` reaches the FormControl
          and stops. It has to carry the same gap itself, or 話題風格, the
          示範資料 note and the CTA end up flush against each other. FormControl
          is already `inline-flex` in a column, so one `gap` is the whole of it.
          NewsMatchingView needs nothing: it returns a bare Fragment, so its
          rows ARE direct children and the drawer spaces them. */}
      <FormControl sx={{ gap: `${SECTION_GAP}px` }}>
        <Grid className={classes.sectionContainer}>
          {/* FormLabelWithIcon, like every other section title in these
              drawers. This was SectionTitleRow — a near-copy of it that agreed
              on nothing: a 26px icon tile against 24, a 16px title against
              14px, #000 against #333, and no support for the required star.
              This was its only call site, so 話題風格 was the one heading in
              the drawer drawn bigger, blacker, and 2px further right than the
              two above it. */}
          <FormLabelWithIcon
            iconName="MessageSquare"
            type="blue"
            labelText={intl.formatMessage({ id: 'gpt-icebreaking-topic-style' })}
          />
          <RadioGroup
            row
            aria-label="topic-style"
            name="topic-creativity"
            value={options.creativity ?? ''}
            onChange={event =>
              _readonly ? undefined : onValueChange('creativity', event.target.value, options.creativity ?? '')
            }
          >
            {creativityOptions.map(({ key, value, label }) => (
              <FormControlLabel
                key={key}
                value={value}
                control={
                  <Radio
                    color="primary"
                    className={classes.radioOption}
                    style={{ paddingTop: '2px', paddingBottom: '2px' }}
                  />
                }
                label={intl.formatMessage({ id: label })}
              />
            ))}
          </RadioGroup>
        </Grid>

        <Grid className={classes.sectionContainer}>
          <RandomDataWarning intl={intl} />
        </Grid>

        {text && <TopicResult intl={intl} text={text} classes={classes} onClear={onClear} />}
        {!text && (
          <Grid className={classes?.sectionContainer || ''}>
            <ActionButton onClick={onGenerate}>
              {'🚀 '}
              {intl.formatMessage({ id: 'gpt-message-generate-cta' })}
            </ActionButton>
          </Grid>
        )}
      </FormControl>
    </Fragment>
  );
};
